export { default as Property } from './Property'
